import { User, } from "firebase/auth";

export type ExternalAuthType = 'google' | 'apple.com'
export const ExternalAuthTypeLabel: Record<ExternalAuthType, string> = {
  google: 'google',
  "apple.com": 'apple'
}

export class ExternalAuthUser {
  email: string | null
  firstname: string | null
  created_from: ExternalAuthType
  newsletter_consent: boolean
  rgpd_consent: boolean
  level_id: number
  token: string

  constructor(response: User, provider: ExternalAuthType, token: string) {
    const onboardingInfos = localStorage.getItem('onboardingInfos') && JSON.parse(localStorage.getItem('onboardingInfos')!);
    this.email = response.email
    this.firstname = onboardingInfos?.firstName || response.displayName
    this.created_from = provider
    this.newsletter_consent = false
    this.rgpd_consent = true
    this.level_id = onboardingInfos?.level_id || 1
    this.token = token
  }
}